<!--  -->
<template>
  <div class="layout-wrap">
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
        v-model:collapsed="collapse"
        :collapsible="true"
        width="250"
        :trigger="null"
        class="layout"
        :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0, zIndex: '10' }"
      >
        <Logo
          :showTitle="!collapse"
          :autoData="autoData"
          @fetchUser="fetchUser"
          @selectChange="selectChange"
          @focusChange="focusChange($event)"
        />
        <a-menu
          theme="dark"
          v-model:selectedKeys="selectedKeys"
          v-model:openKeys="openKeys"
          @click="menuHandleClick"
          mode="inline"
        >
          <template v-for="item in menuList">
            <a-menu-item :key="item.path" v-if="!item.children">
              <Icon :icon="item.meta.icon" />
              <span class="menu-item" v-if="!collapse">{{item.meta.title}}</span>
            </a-menu-item>

            <a-sub-menu :key="item.path" v-if="item.children && item.rolesStatus">
              <template #title>
                <Icon :icon="item.meta.icon" />
                <span class="menu-item" v-if="!collapse">{{item.meta.title}}</span>
              </template>
              <div v-for="(child) in item.children" :key="child.path">
                <a-menu-item v-if="child.rolesStatus" :key="child.path">
                  <router-link :to="child.path">{{child.meta.title}}</router-link>
                </a-menu-item>
              </div>
            </a-sub-menu>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout :style="!collapse ?'margin-left: 250px' : 'margin-left: 80px'">
        <Header :collapsed="collapse" @toggle-collapsed="toggleCollapse" />
        <a-layout-content class="layout-custom">
          <router-view></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  onBeforeMount,
  watchEffect,
  onMounted,
  nextTick,
  computed
} from "vue";
import Header from "./header";
import Logo from "./logo";
import { useRoute, useRouter } from "vue-router";
import Icon from "@/layout/icon";
import routesList from "@/router/routes";
import { useStore } from "vuex";
import FullLoading from "@/components/FullLoading";

import {
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeFilled,
  AppstoreFilled,
  FrownFilled,
  DeliveredProcedureOutlined
} from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    HomeFilled,
    AppstoreFilled,
    DeliveredProcedureOutlined,
    FrownFilled,
    Header,
    Logo,
    Icon,
    FullLoading
  },
  setup() {
    const routes = useRoute();
    const router = useRouter();
    const store = useStore();
    const { currentRoute } = useRouter();
    const state = reactive({
      isFirst: true,
      collapse: false,
      inlineCollapsed: false,
      selectedKeys: [],
      openKeys: [],
      ceshi: [],
      ceshi2: [],
      menuList: [],
      rolesList: null,
      gameList: null
    });
    // logo
    const autoData = reactive({
      autoValue: null,
      data: [],
      fetching: false
    });
    let selectData = [];
    let asscessGamesListRef = computed(
      () => store.state.settings.asscessGamesList
    );
    let isFirstRef = computed(() => store.state.settings.isFirst);
    const rolesList = computed(() => {
      return store.state.settings.roles;
    });
    const fetchUser = value => {
      autoData.fetching = true;
      let data = store.state.settings.asscessGamesList;
      //  data.fileter
      value = value.toLowerCase();
      autoData.data = data.filter(item => {
        let text = [
          item.name,
          item.publish_name,
          item.name_pinyin,
          item.name_pinyin_first_letter,
          item.code
        ]
          .join("【】")
          .toLowerCase();
        setTimeout(() => {
          autoData.fetching = false;
        }, 2000);
        return text.indexOf(value) > -1;
      });
    };
    const focusChange = () => {
      autoData.data = store.state.settings.asscessGamesList;
    };
    const selectChange = value => {
      autoData.data = store.state.settings.asscessGamesList;
      // gameCode 赋值
      store.commit("settings/currentGamgeCodeChange", value);
      store.commit("settings/isFirstChange", false);
      // 语言赋值
      autoData.data.forEach(item => {
        if (item.code === value) {
          store.commit("settings/languagesChange", item.languages);
        }
      });
      router.push("/index");
      rolesChange(value);
    };

    const getCildType = child => {
      console.log(state.rolesList, "state.rolesList");
      // 权限赋值
      let roleType;
      switch (child.name) {
        case "log":
          roleType = state.rolesList.ROLE_TYPE_GATHER_LOG;
          break;
        case "manage":
          roleType = state.rolesList.ROLE_TYPE_GATHER_MANAGE;
        case "search":
        case "messageSearch":
          roleType = state.rolesList.ROLE_TYPE_REGISTER_SEARCH;
          break;
        case "eventList":
          roleType = state.rolesList.ROLE_TYPE_ACTIVITIES_LIST;
          break;
      }
      return roleType;
    };
    const rolesChange = code => {
      state.menuList.forEach(item => {
        item.children?.forEach(child => {
          child.meta.permission = getCildType(child);
          if (child.meta.permission?.findIndex(e => e === code) !== -1) {
            item.rolesStatus = true;
            child.rolesStatus = true;
          }
        });
      });
    };
    onBeforeMount(() => {
      let arrNew = [];
      let filterList = routesList.filter((current, index) => {
        if (current.path == "/") {
          current.children.forEach(child => {
            let childItem = {
              path: "/" + child.path,
              meta: child.meta,
              rolesStatus: false
            };
            arrNew.push(childItem);
          });
        }
        return index !== 0 && current.path !== "/404";
      });
      filterList.forEach(item => {
        item.rolesStatus = false;
        item.children.forEach(child => {
          child.path = `${item.path}/${child.path}`;
        });
      });
      state.menuList = [...arrNew, ...filterList];
    });
    watch(
      [asscessGamesListRef, isFirstRef, rolesList],
      (
        [asscessGamesList, isFirst, newRolesList],
        [preAsscessGamesList, preIsFirst, preRolesList]
      ) => {
        state.rolesList = newRolesList;
        if (asscessGamesList && isFirst) {
          autoData.data = asscessGamesList;
          if (asscessGamesList.length > 0) {
            autoData.autoValue = asscessGamesList[0].name;
            store.commit(
              "settings/languagesChange",
              asscessGamesList[0].languages
            );
            store.commit(
              "settings/currentGamgeCodeChange",
              asscessGamesList[0].code
            );
            rolesChange(asscessGamesList[0].code);
          }
        }
      }
    );
    const toggleCollapse = () => {
      state.collapse = !state.collapse;
    };
    const menuHandleClick = e => {
      console.log(e, "eeeeee");
      router.replace({ path: e.key });
      store.commit("settings/loadingChange", true);
      setTimeout(() => {
        store.commit("settings/loadingChange", false);
      }, 2000);
    };
    // 监听路由
    watchEffect(() => {
      console.log(currentRoute.value, "currentRoute.value");
      if (currentRoute.value.matched.length > 2) {
        state.selectedKeys = [currentRoute.value.matched[1].path];
      } else {
        state.selectedKeys = [currentRoute.value.path];
      }
      state.openKeys = [currentRoute.value.matched[0].path];

      // state.rolesList = store.state.settings.roles;

      state.gameList = store.state.settings.gameCodeList;
    });
    return {
      ...toRefs(state),
      toggleCollapse,
      menuHandleClick,
      routes,
      autoData,
      fetchUser,
      selectChange,
      focusChange
    };
  }
});
</script>
<style lang='less'>
// @import "../antComm/index.css";
.layout-custom {
  height: 100%;
}
.menu-item {
  padding-top: 2px;
  padding-left: 5px;
}
@import "../assets/styles/comm.css";
.layout-wrap {
  display: flex;
  flex: 1;
  height: 100vh;
  .vab-sider {
    position: fixed;
    left: 0;
    // height: 100vh;
    overflow: auto;
    .vab-menu {
      height: calc(100vh - @vab-header-height);
    }
  }
}
.slide-menu {
  #flex-box.row-c-c();
}
</style>